import {
  AddNotificationCountToIndexedDB,
  AddReadNotificationToIndexedDB,
  AddUnreadNotificationToIndexedDB,
  ClearNotificationIndexedDB,
  GetNotificationCountFromIndexedDB,
  GetReadNotificationFromIndexedDB,
  GetUnreadNotificationFromIndexedDB,
  UpdateNotificationCountToIndexedDB,
  UpdateReadNotificationToIndexedDB,
  UpdateUnreadNotificationToIndexedDB,
} from "@/IndexedDB/notificationIndexedDB";
import { CheckIndexedDBIsSupport, ClearTabFromIndexedDB } from "@/IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import {
  BroadcastDisconnectNotificationAllTab,
  BroadcastIsUpdateIsSeenNotificationList,
  BroadcastIsUpdateNotificationCount,
  BroadcastIsUpdateUnSeenNotificationList,
  BroadcastMasterDeleteNotificationById,
  BroadcastMasterSetNotificationIsSeenAll,
  BroadcastMasterSetNotificationIsSeenById,
  BroadcastReCreateTab,
} from "@/broadcastChannel/userChannel";
import {
  FinanceType,
  NotificationMessageType,
  NotificationType,
  TransactionItemType,
  TransactionType,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { NotificationMessageForDisplayModel } from "@/model/notification/NotificationMessageForDisplayModel";
import { NotificationMessageModel } from "@/model/notification/NotificationMessageModel";
import { NotificationMessageOptionModel } from "@/model/notification/NotificationMessageOptionModel";
import { NotificationModel } from "@/model/notification/NotificationModel";
import { ObjectIdListNotification } from "@/model/notification/ObjectIdListNotificationModel";
import store from "@/store";
import Cookies from "js-cookie";
import Vue from "vue";
import { GetCommentTextForDisplay, GetUserIdFromCommentText } from "./shareHelper";
import {
  ClearMasterTabFromCookies,
  ClearTabFromSessionStorage,
  GetAllTabs,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  IsMasterTabAvailable,
  SetMasterTab,
  UpdateTabMerchantId,
} from "./tabHelper";
import { AccessToken, UserId } from "./userHelper";

const appVue = new Vue();

let timerCheckAccessToken = 0;
const socketSessionIdKey = "socketPeakAssetSessionId";

export const SetTimerCheckAccessToken = () => {
  if (IsMasterTab()) {
    timerCheckAccessToken = (setInterval(async () => {
      const isCanUseAccessToken = await store.dispatch("LogIn/DoIntrospectAccessToken", null, { root: true });
      if (isCanUseAccessToken) {
        await store.dispatch("LogIn/DoUpdateAccessToken", null, { root: true });
      } else {
        const isCanNewUseAccessToken = await store.dispatch("LogIn/DoGetNewAccessTokenByRefreshToken", null, {
          root: true,
        });
        if (isCanNewUseAccessToken) {
          await store.dispatch("LogIn/DoUpdateAccessToken", null, { root: true });
        }
      }
    }, 3660000) as unknown) as number;
  }
};

export const ClearTimerCheckAccessToken = () => {
  if (IsMasterTab()) {
    clearInterval(timerCheckAccessToken);
  }
};

export const GetSocketSessionIdFromCookies = () => {
  const socketSessionId = Cookies.get(socketSessionIdKey);
  return socketSessionId ? socketSessionId : null;
};

export const SetSocketSessionIdFromCookies = () => {
  if (appVue.$socket && appVue.$socket.connected) {
    const socketSessionId = appVue.$socket.id;
    Cookies.set(socketSessionIdKey, socketSessionId);
  }
};

export const RemoveSocketSessionIdFromCookies = () => {
  Cookies.remove(socketSessionIdKey);
};

export const CheckStatusSocket = () => {
  if (IsMasterTab()) {
    if (!appVue.$socket || appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const SocketConnect = () => {
  if (IsMasterTab()) {
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else if (!IsMasterTabAvailable()) {
    SetMasterTab();
    if (appVue.$socket && appVue.$socket.disconnected) {
      appVue.$socket.connect();
    }
  } else {
    store.commit("Notification/MutationSetNotificationReadyToUse", true, { root: true });
  }
};

export const SocketAuthentication = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    const eui = btoa(UserId());
    const accessToken = AccessToken();
    appVue.$socket.emit("authentication", {
      eui: eui,
      accessToken: accessToken,
    });
  }
};

export const SocketDisconnect = () => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    appVue.$socket.disconnect();
  }
};

export const DoGetAllNotificationList = (merchantId: number) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("Notification/DoGetAllNotificationList", merchantId, { root: true });
  }
};

export const DoGetUnSeenNotificationList = (merchantId: number) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("Notification/DoGetUnSeenNotificationList", merchantId, { root: true });
  }
};

export const DoGetIsSeenNotificationList = (merchantId: number) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("Notification/DoGetIsSeenNotificationList", merchantId, { root: true });
  }
};

export const DoGetUnseenNotificationCount = (merchantId: number) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("Notification/DoGetUnseenNotificationCount", merchantId, { root: true });
  }
};

export const DoDeleteSeenNotification = (merchantId: number, notificationId: string) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch(
      "Notification/DoDeleteSeenNotification",
      { merchantId: merchantId, notificationId: notificationId },
      { root: true }
    );
  }
};

export const DoDeleteUnseenNotification = (merchantId: number, notificationId: string) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch(
      "Notification/DoDeleteUnseenNotification",
      { merchantId: merchantId, notificationId: notificationId },
      { root: true }
    );
  }
};

export const DoSetAllNotificationIsSeen = (merchantId: number) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("Notification/DoSetAllNotificationIsSeen", merchantId, { root: true });
  }
};

export const DoSetNotificationIsSeen = (merchantId: number, notificationId: string) => {
  if (IsMasterTab() && appVue.$socket && appVue.$socket.connected) {
    store.dispatch("Notification/DoSetNotificationIsSeen", { merchantId: merchantId, notificationId: notificationId });
  }
};

export const DoAddNotificationCount = async (merchantId: number, notificationCount: number) => {
  const notificationCountModelForInsert = {
    merchantId: merchantId,
    notificationCount: notificationCount,
  };
  const notificationCountModel = await GetNotificationCountFromIndexedDB(merchantId);
  if (notificationCountModel) {
    await UpdateNotificationCountToIndexedDB(notificationCountModelForInsert);
  } else {
    await AddNotificationCountToIndexedDB(notificationCountModelForInsert);
  }
};

export const DoGetNotificationCount = async (merchantId: number) => {
  const notificationCountModel = await GetNotificationCountFromIndexedDB(merchantId);
  return notificationCountModel ? notificationCountModel.notificationCount : 0;
};

export const DoAddUnreadNotificationList = async (
  merchantId: number,
  notificationList: Array<NotificationMessageModel>
) => {
  const notificationModelForInsert: NotificationModel = {
    merchantId: merchantId,
    notificationList: notificationList,
  };

  const notificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);

  if (notificationModel) {
    await UpdateUnreadNotificationToIndexedDB(notificationModelForInsert);
  } else {
    await AddUnreadNotificationToIndexedDB(notificationModelForInsert);
  }
};

export const DoGetReadAllNotificationList = async (merchantId: number) => {
  const notificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  return notificationModel ? notificationModel.notificationList : [];
};

export const DoAddReadNotificationList = async (
  merchantId: number,
  notificationList: Array<NotificationMessageModel>
) => {
  const notificationModelForInsert = {
    merchantId: merchantId,
    notificationList: notificationList,
  };
  const notificationModel = await GetReadNotificationFromIndexedDB(merchantId);
  if (notificationModel) {
    await UpdateReadNotificationToIndexedDB(notificationModelForInsert);
  } else {
    await AddReadNotificationToIndexedDB(notificationModelForInsert);
  }
};

export const DoGetUnreadAllNotificationList = async (merchantId: number) => {
  const notificationModel = await GetUnreadNotificationFromIndexedDB(merchantId);
  return notificationModel ? notificationModel.notificationList : [];
};

export const RemoveNotificationFromNotificationList = (
  notificationList: Array<NotificationMessageModel>,
  notificationId: string
) => {
  if (notificationList && notificationList.length > 0) {
    const findIndex = notificationList.findIndex((x) => x.id === notificationId);
    if (findIndex > -1) {
      notificationList.splice(findIndex, 1);
      return notificationList;
    }
    return notificationList;
  }
  return [];
};

export const DoDeleteNotificationByIdFromSOCKET = async (merchantId: number, notificationId: string) => {
  if (IsMasterTab()) {
    let readNotificationList = await DoGetReadAllNotificationList(merchantId);
    readNotificationList = RemoveNotificationFromNotificationList(readNotificationList, notificationId);
    await UpdateReadNotificationToIndexedDB({ merchantId: merchantId, notificationList: readNotificationList });

    let unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    unreadNotificationList = RemoveNotificationFromNotificationList(unreadNotificationList, notificationId);
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: unreadNotificationList });
    const notificationCount = await DoGetNotificationCount(merchantId);
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: notificationCount - 1 });

    await store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  }
};

export const DoDeleteNotificationById = async (merchantId: number, notificationId: string, isSeen: boolean) => {
  if (IsMasterTab()) {
    if (isSeen) {
      DoDeleteSeenNotification(merchantId, notificationId);
    } else {
      DoDeleteUnseenNotification(merchantId, notificationId);
    }
    await DoDeleteNotificationByIdFromSOCKET(merchantId, notificationId);
  } else {
    BroadcastMasterDeleteNotificationById(merchantId, notificationId, isSeen);
  }
};

export const DoSetNotificationIsSeenAllFromSOCKET = async (merchantId: number) => {
  if (IsMasterTab()) {
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: [] });
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: 0 });

    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);
    if (unreadNotificationList && unreadNotificationList.length > 0) {
      await DoAddReadNotificationList(merchantId, [...unreadNotificationList, ...readNotificationList]);
    } else if (readNotificationList && readNotificationList.length > 0) {
      DoGetIsSeenNotificationList(merchantId);
    }

    await store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  }
};

export const DoSetNotificationIsSeenAll = async (merchantId: number) => {
  if (IsMasterTab()) {
    DoSetAllNotificationIsSeen(merchantId);
    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);
    await UpdateUnreadNotificationToIndexedDB({ merchantId: merchantId, notificationList: [] });
    await UpdateNotificationCountToIndexedDB({ merchantId: merchantId, notificationCount: 0 });

    await DoAddReadNotificationList(merchantId, [...unreadNotificationList, ...readNotificationList]);

    await store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  } else {
    BroadcastMasterSetNotificationIsSeenAll(merchantId);
  }
};

export const DoSetNotificationIsSeenByIdFromSOCKET = async (merchantId: number, notificationId: string) => {
  if (IsMasterTab()) {
    const unreadNotificationCount = await DoGetNotificationCount(merchantId);

    await UpdateNotificationCountToIndexedDB({
      merchantId: merchantId,
      notificationCount: unreadNotificationCount - 1,
    });

    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);

    if (unreadNotificationList && unreadNotificationList.length > 0) {
      const unreadNotification = unreadNotificationList.find((x) => x.id == notificationId);

      if (unreadNotification) {
        unreadNotification.isSeen = true;
        await DoAddReadNotificationList(merchantId, [...readNotificationList, unreadNotification]);
      }

      await UpdateUnreadNotificationToIndexedDB({
        merchantId: merchantId,
        notificationList: unreadNotificationList.filter((x) => x.id !== notificationId),
      });
    } else if (readNotificationList && readNotificationList.length > 0) {
      DoGetIsSeenNotificationList(merchantId);
    }

    await store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  }
};

export const DoSetNotificationIsSeenById = async (merchantId: number, notificationId: string) => {
  if (IsMasterTab()) {
    DoSetNotificationIsSeen(merchantId, notificationId);
    const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
    const readNotificationList = await DoGetReadAllNotificationList(merchantId);
    const unreadNotificationCount = await DoGetNotificationCount(merchantId);

    const unreadNotification = unreadNotificationList.find((x) => x.id == notificationId);
    if (unreadNotification) {
      await UpdateNotificationCountToIndexedDB({
        merchantId: merchantId,
        notificationCount: unreadNotificationCount - 1,
      });

      unreadNotification.isSeen = true;
      await DoAddReadNotificationList(merchantId, [...readNotificationList, unreadNotification]);
    }

    await UpdateUnreadNotificationToIndexedDB({
      merchantId: merchantId,
      notificationList: unreadNotificationList.filter((x) => x.id !== notificationId),
    });

    await store.dispatch("Notification/ActionSetNotificationCountFromIndexedDB", null, { root: true });
    BroadcastIsUpdateNotificationCount(merchantId);
    await store.dispatch("Notification/ActionSetUnSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateUnSeenNotificationList(merchantId);
    await store.dispatch("Notification/ActionSetIsSeenNotificationListFromIndexedDB", null, { root: true });
    BroadcastIsUpdateIsSeenNotificationList(merchantId);
  } else {
    BroadcastMasterSetNotificationIsSeenById(merchantId, notificationId);
  }
};

export const SetIsSeenForNotification = (notificationList: Array<NotificationMessageModel>, isSeen: boolean) => {
  if (notificationList && notificationList.length > 0) {
    notificationList.forEach((notificationItem) => {
      notificationItem.isSeen = isSeen;
    });
    return notificationList;
  }
  return [];
};

export const SortDataNotification = (notificationList: Array<NotificationMessageForDisplayModel>) => {
  if (notificationList && notificationList.length > 0) {
    return notificationList.sort((a, b) => {
      const notificationDateTimeA = new Date(a.notificationDateTime);
      const notificationDateTimeB = new Date(b.notificationDateTime);
      return notificationDateTimeB.getTime() - notificationDateTimeA.getTime();
    });
  }
  return [];
};

export const GetObjectIdListNotification = (notificationList: Array<NotificationMessageForDisplayModel>) => {
  const userIdList = [];
  const quotationIdList = [];
  const invoiceIdList = [];
  const receiptIdList = [];
  const taxInvoiceIdList = [];
  const creditNoteIdList = [];
  const debitNoteIdList = [];
  const billingNoteIdList = [];
  const pnd2IdList = [];
  const pnd3IdList = [];
  const pnd53IdList = [];
  const pp30IdList = [];
  const productIdList = [];
  const assetTemplateIdList = [];

  if (notificationList && notificationList.length > 0) {
    for (const notification of notificationList) {
      if (notification.userId > 0) {
        userIdList.push(notification.userId);
      }
      if (notification.option && notification.option.referenceUserId > 0) {
        userIdList.push(notification.option.referenceUserId);
      }
      if (notification.messageTypeId == NotificationMessageType.MentionTransaction) {
        const userIds = GetUserIdFromCommentText(notification.option.messageDescription);
        userIdList.push(...userIds);
      }

      if (notification.option.productId > 0) {
        productIdList.push(notification.option.productId);
      }

      if (notification.option.assetTemplateId > 0) {
        assetTemplateIdList.push(notification.option.assetTemplateId);
      }

      if (notification.option.transactionType == TransactionType.Pnd2) {
        pnd2IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.TaxPND3) {
        pnd3IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.TaxPND53) {
        pnd53IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.TaxPP30) {
        pp30IdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.Quotation) {
        quotationIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.Invoice) {
        invoiceIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.Receipt) {
        receiptIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.TaxInvoice) {
        taxInvoiceIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.CreditNote) {
        creditNoteIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.DebitNote) {
        debitNoteIdList.push(notification.option.transactionId);
      }

      if (notification.option.transactionType == TransactionType.BillingNote) {
        billingNoteIdList.push(notification.option.transactionId);
      }
    }
  }
  const objectIdListNotification: ObjectIdListNotification = {
    userIdList,
    quotationIdList,
    invoiceIdList,
    receiptIdList,
    taxInvoiceIdList,
    creditNoteIdList,
    debitNoteIdList,
    billingNoteIdList,
    pnd2IdList,
    pnd3IdList,
    pnd53IdList,
    pp30IdList,
    productIdList,
    assetTemplateIdList,
  };
  return objectIdListNotification;
};

export const GetUserImageByUserId = (userId: number, userIdListForMap: Map<number, any>) => {
  let userImage = "";
  if (userIdListForMap && userIdListForMap.get(userId)) {
    userImage = userIdListForMap.get(userId).pictureUrl;
  }
  return userImage;
};

export const GetProductCodeByProductId = (productId: number, productCodeListForMap: Map<number, any>) => {
  const productCode = productCodeListForMap.get(productId);
  if (productCode) {
    return productCode.productTemplateCode;
  }
  return "";
};

export const GetAssetTemplateCodeByAssetTemplateId = (
  assetTemplateId: number,
  assetTemplateCodeListForMap: Map<number, any>
) => {
  const assetTemplateCode = assetTemplateCodeListForMap.get(assetTemplateId);
  if (assetTemplateCode) {
    return assetTemplateCode.assetTemplateCode;
  }
  return "";
};

export const GetTransactionNumberFromTransactionTypeListForMap = (
  transactionId: number,
  transactionType: TransactionType,
  transactionTypeListForMap: Map<number, any>
) => {
  const transactionNumberForMap = transactionTypeListForMap.get(transactionType);
  if (transactionNumberForMap) {
    const transactionNumber = transactionNumberForMap.get(transactionId);
    if (transactionNumber) {
      return transactionNumber.number;
    }
  }
  return "";
};

export const GetTransactionFinanceTypeFromTransactionTypeListForMap = (
  transactionId: number,
  transactionType: TransactionType,
  transactionTypeListForMap: Map<number, any>
) => {
  const transactionNumberForMap = transactionTypeListForMap.get(transactionType);
  if (transactionNumberForMap) {
    const transactionNumber = transactionNumberForMap.get(transactionId);
    if (transactionNumber) {
      return transactionNumber.financeType;
    }
  }
  return "";
};

export const GetTransactionItemTypeFromTransactionTypeListForMap = (
  transactionId: number,
  transactionType: TransactionType,
  transactionTypeListForMap: Map<number, any>
) => {
  const transactionNumberForMap = transactionTypeListForMap.get(transactionType);
  if (transactionNumberForMap) {
    const transactionNumber = transactionNumberForMap.get(transactionId);
    if (transactionNumber) {
      return transactionNumber.transactionItemType;
    }
  }
  return "";
};

export const CheckMerchantIsActiveOtherTab = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    const allTabs = await GetAllTabs();
    return allTabs.some((x) => x.id !== tabId && x.merchantId == merchantId);
  }
  return false;
};

export const CheckMerchantIsLoadNotificationUnSeen = async (merchantId: number) => {
  const unreadNotificationList = await DoGetUnreadAllNotificationList(merchantId);
  return unreadNotificationList && unreadNotificationList.length ? true : false;
};

export const CheckMerchantIsLoadNotificationIsSeen = async (merchantId: number) => {
  const readNotificationList = await DoGetReadAllNotificationList(merchantId);
  return readNotificationList && readNotificationList.length ? true : false;
};

export const CheckMerchantIsActive = async (merchantId: number) => {
  let isActive = false;
  if (merchantId > 0) {
    if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
      const allTabs = await GetAllTabs();
      const isHaveSomeTabSameMerchant = allTabs.some((x) => x.merchantId == merchantId);
      if (isHaveSomeTabSameMerchant) {
        isActive = true;
      }
    } else {
      isActive = true;
    }
  }
  return isActive;
};

export const ForceSetMaster = async (merchantId: number) => {
  BroadcastDisconnectNotificationAllTab();
  ClearMasterTabFromCookies();
  ClearTabFromSessionStorage();
  await ClearTabFromIndexedDB();
  await ClearNotificationIndexedDB();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  DoGetUnseenNotificationCount(merchantId);
  BroadcastReCreateTab();
};

export const GetTransactionNameForNotification = (
  transactionType: TransactionType,
  financeType: FinanceType,
  transactionItemType: TransactionItemType = TransactionItemType.None
) => {
  let name: any = "";
  switch (transactionType) {
    case TransactionType.Quotation:
      if (financeType == FinanceType.InFlow) {
        name = i18n.t("Quotation");
      } else {
        if (transactionItemType == TransactionItemType.Asset) {
          name = i18n.t("Purchase_Order_Asset");
        } else {
          name = i18n.t("Purchase_Order");
        }
      }

      break;
    case TransactionType.Invoice:
      if (financeType == FinanceType.InFlow) {
        name = i18n.t("Invoice");
      } else {
        if (transactionItemType == TransactionItemType.Asset) {
          name = i18n.t("Purchase_New_Asset");
        } else {
          name = i18n.t("Expense");
        }
      }
      break;
    case TransactionType.Receipt:
      name = i18n.t("Receipt");
      break;
    case TransactionType.TaxInvoice:
      if (financeType == FinanceType.InFlow) {
        name = i18n.t("Sales_Tax_Invoice");
      } else {
        name = i18n.t("Purchase_Tax_Invoice");
      }

      break;
    case TransactionType.CreditNote:
      if (financeType == FinanceType.InFlow) {
        name = i18n.t("Credit_Note");
      } else {
        name = i18n.t("Receive_Credit_Note");
      }

      break;
    case TransactionType.DebitNote:
      if (financeType == FinanceType.InFlow) {
        name = i18n.t("Debit_Note");
      } else {
        name = i18n.t("Receive_Debit_Note");
      }
      break;
    case TransactionType.BillingNote:
      if (financeType == FinanceType.InFlow) {
        name = i18n.t("Menu_BillingNote");
      } else {
        name = i18n.t("Combined_Payment_Note");
      }
      break;
    case TransactionType.Dailyjournal:
      name = i18n.t("Daily_Journal");
      break;
  }

  return name;
};

export const GetSuccessHeaderReport = (
  messageTypeId: number,
  option: NotificationMessageOptionModel,
  merchant: SelectedMerchantModel,
  userIdListForMap: Map<number, any>,
  transactionTypeListForMap: Map<number, any>,
  productCodeListForMap: Map<number, any>,
  assetTemplateCodeListForMap: Map<number, any>
) => {
  let headerMessage: any = "";
  let descriptionMessage: any = "";

  const merchantName = merchant ? merchant.merchantName : "";
  const messageDescription = option.messageDescription ? option.messageDescription : "";
  const exportFromDate = option.exportFromDate ? option.exportFromDate.GetDateFormat() : "";
  const exportToDate = option.exportToDate ? option.exportToDate.GetDateFormat() : "";
  const transactionCount = option.transactionCount ? option.transactionCount : 0;
  const transactionId = option.transactionId ? option.transactionId : 0;
  const transactionType = option.transactionType ? option.transactionType : 0;
  const productId = option.productId ? option.productId : 0;
  const assetTemplateId = option.assetTemplateId ? option.assetTemplateId : 0;
  const userName = userIdListForMap.get(option.referenceUserId)
    ? userIdListForMap.get(option.referenceUserId).displayName
    : "";
  const messageUrlName = option.messageUrlName ? option.messageUrlName : "";

  switch (messageTypeId) {
    case NotificationMessageType.Quotation:
      headerMessage = i18n.t("Success_QuotationReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.PurcahseOrder:
      headerMessage = i18n.t("Success_POReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Invoice:
    case NotificationMessageType.InvoiceAllProduct:
      headerMessage = i18n.t("Success_InvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Expense:
    case NotificationMessageType.ExpenseAllProduct:
      headerMessage = i18n.t("Success_ExpenseReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.PurchaseAsset:
    case NotificationMessageType.PurchaseAssetAllProduct:
      headerMessage = i18n.t("Success_PurchaseAssetReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Receipt:
      headerMessage = i18n.t("Success_ReceiptReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TaxInvoice:
    case NotificationMessageType.TaxInvoiceInRevenueDepartmentFormat:
      headerMessage = i18n.t("Success_TaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.PurcahseTaxInvoice:
    case NotificationMessageType.PurchaseTaxInvoiceInRevenueDepartFormat:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportTaxInvoiceFromOldPeak:
      headerMessage = i18n.t("Success_TaxInvoiceReportFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportPurchaseTaxInvoiceFromOldPeak:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReportFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportTaxInvoiceFromPeakTax:
      headerMessage = i18n.t("Success_TaxInvoiceReportFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportPurchaseTaxInvoiceFromPeakTax:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReportFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.BillingNoteInvoice:
    case NotificationMessageType.BillingNoteInvoiceAllInvoice:
      headerMessage = i18n.t("Success_BillingNoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.BillingNoteExpense:
    case NotificationMessageType.BillingNoteExpenseAllExpense:
      headerMessage = i18n.t("Success_CombinePaymentNoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.StockActivityStockCardMovement:
      headerMessage = i18n.t("Success_StockMovementReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Journal:
      headerMessage = i18n.t("Success_DailyJournalReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TrialBalance:
    case NotificationMessageType.TrialBalanceWithSubAccount:
      headerMessage = i18n.t("Success_TrialBalanceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TrialBalanceSeperateMonth:
      headerMessage = i18n.t("Success_TrialBalanceSeperateMonthReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Finance:
      headerMessage = i18n.t("Success_FinanceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.PP30InputVat:
      headerMessage = i18n.t("Success_PP30InputVat");
      break;
    case NotificationMessageType.PP30OutputVat:
      headerMessage = i18n.t("Success_PP30OutputVat");
      break;
    case NotificationMessageType.CreditNote:
      headerMessage = i18n.t("Success_CreditnoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.CreditNoteExpense:
      headerMessage = i18n.t("Success_CreditnoteExpenseReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AssetTemplate:
      headerMessage = i18n.t("Success_AssetTemplateReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AssetTemplateGroup:
      headerMessage = i18n.t("Success_AssetTemplateGroupReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.WithHeldTax:
      headerMessage = i18n.t("Success_WithHeldTaxReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.WithHoldingTax:
      headerMessage = i18n.t("Success_WithHoldingTaxReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.GeneralLedgerTransaction:
      headerMessage = i18n.t("Success_GeneralLedger_Transaction");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllGeneralLedger:
      headerMessage = i18n.t("Success_AllGeneralLedger");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllGeneralLedgerWithSubAccount:
      headerMessage = i18n.t("Success_GeneralLedger_Transaction");
      break;
    case NotificationMessageType.AgingReportAR:
      headerMessage = i18n.t("Success_Aging_Report_AR");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AgingReportAP:
      headerMessage = i18n.t("Success_Aging_Report_AP");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Product:
      headerMessage = i18n.t("Success_Product");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.ProfitLoss:
      headerMessage = i18n.t("Success_ProfitLoss");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.ChartOfAccount:
      headerMessage = i18n.t("Success_ChartOfAccount");
      descriptionMessage = i18n.t("Success_ChartOfAccount_Description", {
        merchantName: merchantName,
      });
      break;
    case NotificationMessageType.BalanceSheet:
      headerMessage = i18n.t("Success_BalanceSheet");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Unit:
      headerMessage = i18n.t("Success_Unit");
      break;
    case NotificationMessageType.ReportDocument:
      headerMessage = i18n.t("Success_ReportDocument");
      break;
    case NotificationMessageType.Asset:
      headerMessage = i18n.t("Success_AssetReport");
      descriptionMessage = i18n.t("Success_AssetReport_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
        assetGroupCode: GetAssetTemplateCodeByAssetTemplateId(assetTemplateId, assetTemplateCodeListForMap),
      });
      break;
    case NotificationMessageType.StatementEFiling:
      headerMessage = i18n.t("Success_StatementEFiling");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Contact:
      headerMessage = i18n.t("Success_ReportContact");
      break;
    case NotificationMessageType.PurchaseTaxInvoiceNotUse:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUse");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.SalesTaxInvoiceNotUse:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUse");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromOldPeak:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUseFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromOldPeak:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUseFromOldPeak");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromPeakTax:
      headerMessage = i18n.t("AllReportPurchaseTaxInvoiceNotUseFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromPeakTax:
      headerMessage = i18n.t("AllReportSalesTaxInvoiceNotUseFromPeakTax");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.PP30TaxFilingTextFile:
      headerMessage = i18n.t("Success_PP30TaxFilingTextFile");
      break;
    case NotificationMessageType.WithHoldingTaxPND2:
      headerMessage = i18n.t("Success_WithHoldingTaxPND2");
      break;
    case NotificationMessageType.WithHoldingTaxPND3:
      headerMessage = i18n.t("Success_WithHoldingTaxPND3");
      break;
    case NotificationMessageType.WithHoldingTaxPND53:
      headerMessage = i18n.t("Success_WithHoldingTaxPND53");
      break;
    case NotificationMessageType.CashflowStatementReport:
      headerMessage = i18n.t("Success_CashflowStatementReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportSalesByCustomerReport:
      headerMessage = i18n.t("Success_AllReportSalesByCustomerReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportSalesByAccountReport:
      headerMessage = i18n.t("Success_AllReportSalesByAccountReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.StatementEFilingExcel:
      headerMessage = i18n.t("Success_StatementEFilingExcel");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportProductSalesByContact:
      headerMessage = i18n.t("Success_AllReportProductSalesByContact");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReport_ProductServiceSalesSummaryReportOnDailyAccount:
      headerMessage = i18n.t("Success_AllReport_ProductServiceSalesSummaryReportOnDailyAccount");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReport_RemainingFinanceBalanceReport:
      headerMessage = i18n.t("Success_AllReport_RemainingFinanceBalanceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.Pnd53TaxFilingTextFile:
      headerMessage = i18n.t("Success_Pnd53TaxFilingTextFile");
      break;
    case NotificationMessageType.Pnd3TaxFilingTextFile:
      headerMessage = i18n.t("Success_Pnd3TaxFilingTextFile");
      break;
    case NotificationMessageType.DailyJournal:
      headerMessage = i18n.t("Success_DailyJournal");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.Dailyjournal, FinanceType.None),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentQuotation:
      headerMessage = i18n.t("Success_DocumentQuotation");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.Quotation, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentInvoice:
      headerMessage = i18n.t("Success_DocumentInvoice");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.Invoice, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentReceipt:
      headerMessage = i18n.t("Success_DocumentReceipt");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.Receipt, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentTaxInvoice:
      headerMessage = i18n.t("Success_DocumentTaxInvoice");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.TaxInvoice, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentPurchaseOrder:
      headerMessage = i18n.t("Success_DocumentPurchaseOrder");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.Quotation, FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentExpense:
      headerMessage = i18n.t("Success_DocumentExpense");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.Invoice, FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentBillingNote:
      headerMessage = i18n.t("Success_DocumentBillingNote");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.BillingNote, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentBillingNoteExpense:
      headerMessage = i18n.t("Success_DocumentBillingNoteExpress");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.BillingNote, FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentCreditNote:
      headerMessage = i18n.t("Success_DocumentCreditNote");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.CreditNote, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentCreditNoteExpense:
      headerMessage = i18n.t("Success_DocumentCreditNoteExpress");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.CreditNote, FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentPurchaseTaxInvoice:
      headerMessage = i18n.t("Success_DocumentPurchaseTaxInvoice");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.TaxInvoice, FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentWithholdingTax:
      headerMessage = i18n.t("Success_DocumentWithholdingTax");
      break;
    case NotificationMessageType.ImportTransactionPurchaseInventory:
      headerMessage = i18n.t("Success_ImportTransactionPurchaseInventory");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.ImportTransactionExpense:
      headerMessage = i18n.t("Success_ImportTransactionExpense");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.ImportTransactionInvoice:
      headerMessage = i18n.t("Success_ImportTransactionInvoice");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.ImportTransactionReceipt:
      headerMessage = i18n.t("Success_ImportTransactionReceipt");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.ImportTransactionQuotation:
      headerMessage = i18n.t("Success_ImportTransactionQuotation");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.ImportTransactionPurchaseOrder:
      headerMessage = i18n.t("Success_ImportTransactionPurchaseOrder");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.Statement:
      headerMessage = i18n.t("Success_Statement");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportWithHoldingTaxPND2:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND2");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportWithHoldingTaxPND3:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND3");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.AllReportWithHoldingTaxPND53:
      headerMessage = i18n.t("Success_AllReportWithHoldingTaxPND53");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.ChequeReport:
      headerMessage = i18n.t("Success_ChequeReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.WorkingPaper:
      headerMessage = i18n.t("Success_WorkingPaperReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.RecalCostOfGoodSoldByMerchantCalculated:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldByMerchantCalculated");
      break;
    case NotificationMessageType.RecalCostOfGoodSoldByProductCalculated:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldByProductCalculated");
      descriptionMessage = i18n.t("Product_Code_Description", {
        productCode: GetProductCodeByProductId(productId, productCodeListForMap),
      });
      break;
    case NotificationMessageType.RecalCostOfGoodSoldFailed:
      headerMessage = i18n.t("Success_RecalCostOfGoodSoldFailed");
      descriptionMessage = i18n.t("Product_Code_Description", {
        productCode: GetProductCodeByProductId(productId, productCodeListForMap),
      });
      break;
    case NotificationMessageType.DebitNote:
      headerMessage = i18n.t("Success_DebitNoteReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.DebitNoteExpense:
      headerMessage = i18n.t("Success_DebitNoteExpenseReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.DocumentDebitNote:
      headerMessage = i18n.t("Success_DocumentDebitNote");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.DebitNote, FinanceType.InFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DocumentDebitNoteExpense:
      headerMessage = i18n.t("Success_DocumentDebitNoteExpense");
      descriptionMessage = i18n.t("Download_Transaction_Description", {
        transactionType: GetTransactionNameForNotification(TransactionType.DebitNote, FinanceType.OutFlow),
        x: transactionCount,
      });
      break;
    case NotificationMessageType.VoidImportTransactionFailed:
      headerMessage = i18n.t("Success_VoidImportTransactionFailed");
      descriptionMessage = i18n.t("Import_Code_Description", {
        importNumber: messageUrlName,
      });
      break;
    case NotificationMessageType.VoidImportTransactionSuccess:
      headerMessage = i18n.t("Success_VoidImportTransactionSuccess");
      descriptionMessage = i18n.t("Import_Code_Description", {
        importNumber: messageUrlName,
      });
      break;
    case NotificationMessageType.ImportTransactionReceiptFromInvoice:
      headerMessage = i18n.t("Success_ImportTransactionReceiptFromInvoice");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.ImportTransactionJournal:
      headerMessage = i18n.t("Success_ImportTransactionJournal");
      descriptionMessage = i18n.t("Import_Code_And_Count_Transaction_Description", {
        importNumber: messageUrlName,
        x: transactionCount,
      });
      break;
    case NotificationMessageType.DepreciateAssetMonthly:
      headerMessage = i18n.t("Success_DepreciateAssetMonthly") + " " + messageDescription;
      break;
    case NotificationMessageType.TaxPnd:
      headerMessage = i18n.t("Success_WithHoldingTaxReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TaxPP30SaleTax:
      headerMessage = i18n.t("Success_TaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TaxPP30PurchaseTax:
      headerMessage = i18n.t("Success_PurchaseTaxInvoiceReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TaxFetchPP30Transaction:
      headerMessage = i18n.t("Success_TaxFetchPP30Transaction");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.TaxFetchWhtCertificate:
      headerMessage = i18n.t("Success_TaxFetchWhtCertificate");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.FinanceBankStatement:
      headerMessage = i18n.t("Success_FinanceBankStatementReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.ExecutiveSummary:
      headerMessage = i18n.t("Success_ExecutiveSummaryReport");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.StatementOfCashflow:
      headerMessage = i18n.t("Success_StatementOfCashflow");
      descriptionMessage = i18n.t("Export_Period_Description", {
        fromDate: exportFromDate,
        toDate: exportToDate,
      });
      break;
    case NotificationMessageType.MentionTransaction:
      headerMessage = i18n.t("Success_MentionTransaction", {
        userName: userName,
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap
        ),
      });
      descriptionMessage = GetCommentTextForDisplay(messageDescription, userIdListForMap);
      break;
    case NotificationMessageType.ApprovedTransaction:
      headerMessage = i18n.t("Success_ApprovedTransaction", {
        userName: userName,
      });
      descriptionMessage = i18n.t("Success_ApprovedTransaction_Description", {
        transactionType: GetTransactionNameForNotification(
          transactionType,
          GetTransactionFinanceTypeFromTransactionTypeListForMap(
            transactionId,
            transactionType,
            transactionTypeListForMap
          ),
          GetTransactionItemTypeFromTransactionTypeListForMap(transactionId, transactionType, transactionTypeListForMap)
        ),
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap
        ),
      });
      break;
    case NotificationMessageType.SendApprovedDocumentTransaction:
      headerMessage = i18n.t("Success_SendApprovedTransaction", {
        userName: userName,
      });
      descriptionMessage = i18n.t("Success_SendApprovedTransaction_Description", {
        transactionType: GetTransactionNameForNotification(
          transactionType,
          GetTransactionFinanceTypeFromTransactionTypeListForMap(
            transactionId,
            transactionType,
            transactionTypeListForMap
          ),
          GetTransactionItemTypeFromTransactionTypeListForMap(transactionId, transactionType, transactionTypeListForMap)
        ),
        transactionNumber: GetTransactionNumberFromTransactionTypeListForMap(
          transactionId,
          transactionType,
          transactionTypeListForMap
        ),
      });
      break;
    case NotificationMessageType.RemovePeakSupport:
      headerMessage = i18n.t("Success_RemovePeakSupport");
      descriptionMessage = i18n.t("Success_RemovePeakSupport_Description");
      break;
    case NotificationMessageType.RecieveBenefit:
    case NotificationMessageType.CamPaignBeforeExpire:
    case NotificationMessageType.BeforeExpireByDate:
    case NotificationMessageType.QuotaExpire:
      headerMessage = messageDescription;
      break;
  }
  return { headerMessage, descriptionMessage };
};

export const ConvertToNotificationMessageForDisplayModel = (notification: NotificationMessageModel) => {
  const notificationMessageForDisplay: NotificationMessageForDisplayModel = new NotificationMessageForDisplayModel();
  notificationMessageForDisplay.id = notification.id;
  notificationMessageForDisplay.merchantId = notification.merchantId;
  notificationMessageForDisplay.userId = notification.userId;
  notificationMessageForDisplay.notificationTypeId = notification.notificationTypeId;
  notificationMessageForDisplay.messageTypeId = notification.messageTypeId;
  notificationMessageForDisplay.notificationDateTime = notification.notificationDateTime;
  notificationMessageForDisplay.option = notification.option;
  notificationMessageForDisplay.isSeen = notification.isSeen;
  return notificationMessageForDisplay;
};

export const ConvertNotificationMessageListToNotificationMessageForDisplayList = (
  getUnSeenNotificationList: Array<NotificationMessageModel>
) => {
  const allNotificationList: Array<NotificationMessageForDisplayModel> = [];
  if (getUnSeenNotificationList && getUnSeenNotificationList.length > 0) {
    for (const getUnSeenNotification of getUnSeenNotificationList) {
      allNotificationList.push(ConvertToNotificationMessageForDisplayModel(getUnSeenNotification));
    }
  }
  return allNotificationList;
};

export const GetStatusIconNameAndColorByType = (messageTypeId: NotificationMessageType) => {
  switch (messageTypeId) {
    case NotificationMessageType.ImportTransactionPurchaseInventory:
    case NotificationMessageType.ImportTransactionExpense:
    case NotificationMessageType.ImportTransactionInvoice:
    case NotificationMessageType.ImportTransactionReceipt:
    case NotificationMessageType.ImportTransactionQuotation:
    case NotificationMessageType.ImportTransactionPurchaseOrder:
    case NotificationMessageType.ImportTransactionReceiptFromInvoice:
    case NotificationMessageType.ImportTransactionJournal:
      return {
        name: "fas fa-file-upload",
        color: "#43BF76",
      };
    case NotificationMessageType.VoidImportTransactionFailed:
      return {
        name: "icon-file_error",
        color: "#F1502F",
      };
    case NotificationMessageType.MentionTransaction:
      return {
        name: "icon-mention",
        color: "#5CACFF",
      };
    case NotificationMessageType.RemovePeakSupport:
      return {
        name: "fas fa-user-slash",
        color: "#FF6547",
      };
    case NotificationMessageType.ApprovedTransaction:
      return {
        name: "icon-file_success",
        color: "#43BF76",
      };
    case NotificationMessageType.SendApprovedDocumentTransaction:
      return {
        name: "fas fa-clock",
        color: "#ff9e40",
      };
    case NotificationMessageType.RecieveBenefit:
    case NotificationMessageType.CamPaignBeforeExpire:
    case NotificationMessageType.BeforeExpireByDate:
    case NotificationMessageType.QuotaExpire:
    case NotificationMessageType.RecalCostOfGoodSoldByMerchantCalculated:
    case NotificationMessageType.RecalCostOfGoodSoldByProductCalculated:
    case NotificationMessageType.RecalCostOfGoodSoldFailed:
    case NotificationMessageType.VoidImportTransactionSuccess:
    case NotificationMessageType.DepreciateAssetMonthly:
      return {
        name: "fas fa-check-circle",
        color: "#43BF76",
      };
    case NotificationMessageType.DocumentQuotation:
    case NotificationMessageType.DocumentInvoice:
    case NotificationMessageType.DocumentReceipt:
    case NotificationMessageType.DocumentTaxInvoice:
    case NotificationMessageType.DocumentPurchaseOrder:
    case NotificationMessageType.DocumentExpense:
    case NotificationMessageType.DocumentBillingNote:
    case NotificationMessageType.DocumentBillingNoteExpense:
    case NotificationMessageType.DocumentCreditNote:
    case NotificationMessageType.DocumentCreditNoteExpense:
    case NotificationMessageType.DocumentPurchaseTaxInvoice:
    case NotificationMessageType.DocumentWithholdingTax:
    case NotificationMessageType.DocumentDebitNote:
    case NotificationMessageType.DocumentDebitNoteExpense:
    case NotificationMessageType.DailyJournal:
      return {
        name: "fas fa-file-pdf",
        color: "#F1502F",
      };
    case NotificationMessageType.ReportDocument:
    case NotificationMessageType.StatementEFiling:
      return {
        name: "fas fa-file-alt",
        color: "#6c6df2",
      };
    case NotificationMessageType.PP30TaxFilingTextFile:
    case NotificationMessageType.WithHoldingTaxPND2:
    case NotificationMessageType.WithHoldingTaxPND3:
    case NotificationMessageType.WithHoldingTaxPND53:
      return {
        name: "icon-file_text",
        color: "#3297FF",
      };
    case NotificationMessageType.AgingReportAP:
    case NotificationMessageType.AgingReportAR:
    case NotificationMessageType.AllGeneralLedger:
    case NotificationMessageType.Asset:
    case NotificationMessageType.AssetTemplateGroup:
    case NotificationMessageType.AssetTemplate:
    case NotificationMessageType.BalanceSheet:
    case NotificationMessageType.BillingNoteInvoice:
    case NotificationMessageType.BillingNoteInvoiceAllInvoice:
    case NotificationMessageType.ChartOfAccount:
    case NotificationMessageType.BillingNoteExpense:
    case NotificationMessageType.BillingNoteExpenseAllExpense:
    case NotificationMessageType.CreditNoteExpense:
    case NotificationMessageType.CreditNote:
    case NotificationMessageType.Journal:
    case NotificationMessageType.Expense:
    case NotificationMessageType.ExpenseAllProduct:
    case NotificationMessageType.Finance:
    case NotificationMessageType.GeneralLedgerTransaction:
    case NotificationMessageType.Invoice:
    case NotificationMessageType.InvoiceAllProduct:
    case NotificationMessageType.PurcahseOrder:
    case NotificationMessageType.PP30InputVat:
    case NotificationMessageType.PP30OutputVat:
    case NotificationMessageType.Product:
    case NotificationMessageType.ProfitLoss:
    case NotificationMessageType.PurchaseAsset:
    case NotificationMessageType.PurchaseAssetAllProduct:
    case NotificationMessageType.PurcahseTaxInvoice:
    case NotificationMessageType.PurchaseTaxInvoiceInRevenueDepartFormat:
    case NotificationMessageType.Quotation:
    case NotificationMessageType.Receipt:
    case NotificationMessageType.StockActivityStockCardMovement:
    case NotificationMessageType.TaxPP30SaleTax:
    case NotificationMessageType.TrialBalanceWithSubAccount:
    case NotificationMessageType.Unit:
    case NotificationMessageType.WithHeldTax:
    case NotificationMessageType.WithHoldingTax:
    case NotificationMessageType.Contact:
    case NotificationMessageType.PurchaseTaxInvoiceNotUse:
    case NotificationMessageType.SalesTaxInvoiceNotUse:
    case NotificationMessageType.CashflowStatementReport:
    case NotificationMessageType.AllReportSalesByCustomerReport:
    case NotificationMessageType.AllReportSalesByAccountReport:
    case NotificationMessageType.AllReportProductSalesByContact:
    case NotificationMessageType.AllReport_ProductServiceSalesSummaryReportOnDailyAccount:
    case NotificationMessageType.AllReport_RemainingFinanceBalanceReport:
    case NotificationMessageType.Pnd53TaxFilingTextFile:
    case NotificationMessageType.Pnd3TaxFilingTextFile:
    case NotificationMessageType.Statement:
    case NotificationMessageType.AllReportWithHoldingTaxPND2:
    case NotificationMessageType.AllReportWithHoldingTaxPND3:
    case NotificationMessageType.AllReportWithHoldingTaxPND53:
    case NotificationMessageType.ChequeReport:
    case NotificationMessageType.WorkingPaper:
    case NotificationMessageType.TrialBalanceSeperateMonth:
    case NotificationMessageType.TaxFetchPP30Transaction:
    case NotificationMessageType.TaxFetchWhtCertificate:
    case NotificationMessageType.AllReportPurchaseTaxInvoiceFromOldPeak:
    case NotificationMessageType.AllReportPurchaseTaxInvoiceFromPeakTax:
    case NotificationMessageType.AllReportTaxInvoiceFromOldPeak:
    case NotificationMessageType.AllReportTaxInvoiceFromPeakTax:
    case NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromOldPeak:
    case NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromOldPeak:
    case NotificationMessageType.AllReportPurchaseTaxInvoiceNotUseFromPeakTax:
    case NotificationMessageType.AllReportSalesTaxInvoiceNotUseFromPeakTax:
    case NotificationMessageType.FinanceBankStatement:
    case NotificationMessageType.ExecutiveSummary:
    case NotificationMessageType.StatementOfCashflow:
    case NotificationMessageType.StatementEFilingExcel:
    case NotificationMessageType.DebitNote:
    case NotificationMessageType.DebitNoteExpense:
    case NotificationMessageType.TaxInvoice:
    case NotificationMessageType.TaxInvoiceInRevenueDepartmentFormat:
    case NotificationMessageType.TaxPnd:
    case NotificationMessageType.TaxPP30PurchaseTax:
    case NotificationMessageType.TrialBalance:
      return {
        name: "fas fa-file-excel",
        color: "#2E8552",
      };

    default:
      return {
        name: "",
        color: "",
      };
  }
  // icon for send approve
  // name: "fas fa-clock",
  // color: "#FF9E40",
};

export const GetAllDataForDisplayNotification = async (
  objectId: ObjectIdListNotification,
  notificationList: Array<NotificationMessageForDisplayModel>,
  merchant: SelectedMerchantModel
) => {
  //#region Get User Detail
  await store.dispatch("Notification/DoGetUserByUserId", objectId.userIdList, { root: true });
  //#endregion

  //#region Get Transaction Code
  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.quotationIdList,
      transactionType: TransactionType.Quotation,
    },
    { root: true }
  );

  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.invoiceIdList,
      transactionType: TransactionType.Invoice,
    },
    { root: true }
  );

  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.receiptIdList,
      transactionType: TransactionType.Receipt,
    },
    { root: true }
  );

  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.taxInvoiceIdList,
      transactionType: TransactionType.TaxInvoice,
    },
    { root: true }
  );

  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.creditNoteIdList,
      transactionType: TransactionType.CreditNote,
    },
    { root: true }
  );

  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.debitNoteIdList,
      transactionType: TransactionType.DebitNote,
    },
    { root: true }
  );

  await store.dispatch(
    "Notification/DoGetTransactionNumberForDisplay",
    {
      transactionIdList: objectId.billingNoteIdList,
      transactionType: TransactionType.BillingNote,
    },
    { root: true }
  );
  //#endregion

  //#region Get Product Code
  await store.dispatch("Notification/DoGetProductCodeForDisplay", objectId.productIdList, { root: true });
  //#endregion

  //#region Get assetTemplate Code
  await store.dispatch("Notification/DoGetAssetTemplateCodeForDisplay", objectId.assetTemplateIdList, { root: true });
  //#endregion

  const userIdListForMap = store.getters["Notification/getUserIdListForMap"];
  const transactionTypeListForMap = store.getters["Notification/getTransactionTypeListForMap"];
  const productCodeListForMap = store.getters["Notification/getProductCodeListForMap"];
  const assetTemplateCodeListForMap = store.getters["Notification/getAssetTemplateCodeListForMap"];

  if (notificationList && notificationList.length > 0) {
    notificationList.forEach((notification) => {
      notification.icon = GetStatusIconNameAndColorByType(notification.messageTypeId);

      notification.message = GetSuccessHeaderReport(
        notification.messageTypeId,
        notification.option,
        merchant,
        userIdListForMap,
        transactionTypeListForMap,
        productCodeListForMap,
        assetTemplateCodeListForMap
      );

      const blobStorage = process.env.VUE_APP_PeakBlobStorage?.toString() ?? "";

      if (notification.option && notification.option.referenceUserId > 0) {
        notification.notificationUrlImage = GetUserImageByUserId(notification.option.referenceUserId, userIdListForMap);
      } else if (notification.notificationTypeId == NotificationType.System) {
        notification.notificationUrlImage =
          blobStorage.UrlCombine("/peakengine/Content/Image/Notification/notification_icon_system.png") ?? "";
      } else {
        notification.notificationUrlImage =
          blobStorage.UrlCombine("/peakengine/Content/Image/Notification/notification_icon_download.png") ?? "";
      }
    });
  }
};

export const CheckNotificationIsNotChangeURL = (messageTypeId: NotificationMessageType) => {
  const notificationIsNotChangeURLMap = new Set([
    NotificationMessageType.DepreciateAssetMonthly,
    NotificationMessageType.RemovePeakSupport,
  ]);
  return notificationIsNotChangeURLMap.has(messageTypeId);
};
